import { Component, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent {

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onConfirm: EventEmitter<any> = new EventEmitter<any>();

  public dialogRef?;

  @ViewChild('template') template!: TemplateRef<any>;

  public msg = '';
  public data;
  // Labels/título opcionais (default mantém o comportamento antigo).
  public title = 'Atenção';
  public confirmText = 'Confirmar';
  public cancelText = 'Cancelar';

  constructor(public dialog: MatDialog) {}

  openModal(msg: any, data: any, options?: { confirmText?: string; cancelText?: string; title?: string }) {
    this.data = data;
    this.msg = msg;
    this.title = options?.title ?? 'Atenção';
    this.confirmText = options?.confirmText ?? 'Confirmar';
    this.cancelText = options?.cancelText ?? 'Cancelar';

    this.dialogRef = this.dialog.open(this.template, {
      width: '404px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: 'custom-dialog-container',
      backdropClass: 'backdrop-class-RSM',
    });
  }

  public onClonseButton() {
    this.onClose.emit();
    this.dialogRef?.close();
  }

  public onConfirmButton() {
    this.onConfirm.emit(this.data);
    this.dialogRef?.close();
  }
}
